export const fr = [
  { _id: 'alencia', name: 'Alencia', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  { _id: 'ambitious-tywin', name: 'Tywin ambitieux', rarity: 5, role: 'knight', attribute: 'light', zodiac: 'archer' },
  { _id: 'apocalypse-ravi', name: 'Ravi Apocalypse', rarity: 5, role: 'warrior', attribute: 'dark', zodiac: 'crab' },
  { _id: 'aramintha', name: 'Aramintha', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'arbiter-vildred', name: 'Vildred arbitre', rarity: 5, role: 'assassin', attribute: 'dark', zodiac: 'lion' },
  {
    _id: 'archdemons-shadow',
    name: "Ombre de l'Archid\u00e9mon",
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  { _id: 'baal-sezan', name: 'Baal et Sezan', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'baiken', name: 'Baiken', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'basar', name: 'Basar', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'waterbearer' },
  { _id: 'bellona', name: 'Bellona', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'blood-moon-haste',
    name: 'Haste Lune de sang',
    rarity: 5,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'bomb-model-kanna',
    name: 'Kanna, mod\u00e8le explosive',
    rarity: 5,
    role: 'ranger',
    attribute: 'fire',
    zodiac: 'twins',
  },
  {
    _id: 'briar-witch-iseria',
    name: 'Iseria Sorci\u00e8re cendr\u00e9e',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'cecilia', name: 'C\u00e9cilia', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'celine', name: 'C\u00e9line', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'cerise', name: 'Cerise', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'cermia', name: 'Cermia', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'lion' },
  { _id: 'charles', name: 'Charles', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'charlotte', name: 'Charlotte', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'lion' },
  { _id: 'chloe', name: 'Chloe', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'archer' },
  { _id: 'choux', name: 'Chou', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'goat' },
  { _id: 'dark-corvus', name: 'Corvus obscur', rarity: 5, role: 'warrior', attribute: 'dark', zodiac: 'goat' },
  {
    _id: 'desert-jewel-basar',
    name: 'Basar, joyau du d\u00e9sert',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'archer',
  },
  { _id: 'designer-lilibet', name: 'Lilibet styliste', rarity: 5, role: 'warrior', attribute: 'dark', zodiac: 'crab' },
  { _id: 'destina', name: 'Destina', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'crab' },
  { _id: 'diene', name: 'Di\u00e8ne', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'dizzy', name: 'Dizzy', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'eda', name: 'Eda', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'elena', name: 'Elena', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'elphelt', name: 'Elphelt', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'goat' },
  { _id: 'ervalen', name: 'Ervalen', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  {
    _id: 'fairytale-tenebria',
    name: 'Tenebria des merveilles',
    rarity: 5,
    role: 'mage',
    attribute: 'ice',
    zodiac: 'bull',
  },
  { _id: 'faithless-lidica', name: 'Lidica impie', rarity: 5, role: 'ranger', attribute: 'light', zodiac: 'twins' },
  {
    _id: 'fallen-cecilia',
    name: 'C\u00e9cilia d\u00e9chue',
    rarity: 5,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'flan', name: 'Phlan', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'goat' },
  { _id: 'haste', name: 'Haste', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'holiday-yufine',
    name: 'Yufine vacanci\u00e8re',
    rarity: 5,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'scales',
  },
  { _id: 'iseria', name: 'Iseria', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  { _id: 'judge-kise', name: 'Juge Kise', rarity: 5, role: 'warrior', attribute: 'light', zodiac: 'maiden' },
  { _id: 'kawerik', name: 'Kawerik', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'kayron', name: 'Kayron', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'ram' },
  { _id: 'ken', name: 'Ken', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'kise', name: 'Kise', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'krau', name: 'Krau', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'fish' },
  { _id: 'landy', name: 'Landy', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'last-rider-krau',
    name: "Krau l'ultime rider",
    rarity: 5,
    role: 'knight',
    attribute: 'light',
    zodiac: 'fish',
  },
  { _id: 'lidica', name: 'Lidica', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'lilias', name: 'Lilias', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'lilibet', name: 'Lilibet', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  {
    _id: 'little-queen-charlotte',
    name: 'Charlotte jeune reine',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'ludwig', name: 'Ludwig', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'lion' },
  { _id: 'luluca', name: 'Luluca', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'luna', name: 'Luna', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  { _id: 'maid-chloe', name: 'Chloe servante', rarity: 5, role: 'manauser', attribute: 'light', zodiac: 'maiden' },
  {
    _id: 'martial-artist-ken',
    name: 'Ken artiste martial',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'mediator-kawerik',
    name: 'Kawerik le m\u00e9diateur',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'goat',
  },
  { _id: 'melissa', name: 'M\u00e9lissa', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'lion' },
  { _id: 'mort', name: 'Mort\u00e9', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'mui', name: 'Mui', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'operator-sigret',
    name: 'Sigret op\u00e9ratrice',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'scales',
  },
  { _id: 'pavel', name: 'Pavel', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  { _id: 'politis', name: 'Politis', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'ravi', name: 'Ravi', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'ray', name: 'Ray', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'bull' },
  { _id: 'remnant-violet', name: 'Violet reminiscent', rarity: 5, role: 'assassin', attribute: 'dark', zodiac: 'lion' },
  { _id: 'roana', name: 'Roenna', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'fish' },
  {
    _id: 'ruele-of-light',
    name: 'Ruele de lumi\u00e8re',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'fish',
  },
  { _id: 'sage-baal-sezan', name: 'Sage Baal et Sezan', rarity: 5, role: 'mage', attribute: 'light', zodiac: 'bull' },
  { _id: 'seaside-bellona', name: 'Bellona plage', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'twins' },
  { _id: 'senya', name: 'Shennah', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'bull' },
  { _id: 'sez', name: 'Sez', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'sigret', name: 'Sigret', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'bull' },
  {
    _id: 'silver-blade-aramintha',
    name: "Aramintha Lame d'argent",
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'twins',
  },
  { _id: 'sol', name: 'Sol', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'archer' },
  {
    _id: 'solitaria-of-the-snow',
    name: 'Solitaria des neiges',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'specimen-sez',
    name: 'Sez sp\u00e9cimen',
    rarity: 5,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  { _id: 'specter-tenebria', name: 'Tenebria spectrale', rarity: 5, role: 'mage', attribute: 'dark', zodiac: 'twins' },
  { _id: 'tamarinne', name: 'Tamarinne', rarity: 5, role: 'manauser', attribute: 'fire', zodiac: 'archer' },
  { _id: 'tenebria', name: 'Tenebria', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'crab' },
  {
    _id: 'top-model-luluca',
    name: 'Luluca Top-mod\u00e8le',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'tywin', name: 'Tywin', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'ram' },
  { _id: 'vildred', name: 'Vildred', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'lion' },
  { _id: 'violet', name: 'Violet', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'vivian', name: 'Vivian', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  { _id: 'yufine', name: 'Yufine', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'bull' },
  { _id: 'yuna', name: 'Yuna', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  { _id: 'zeno', name: 'Zeno', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'achates', name: 'Achates', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'twins' },
  { _id: 'angelica', name: 'Angelica', rarity: 4, role: 'manauser', attribute: 'ice', zodiac: 'crab' },
  { _id: 'armin', name: 'Armin', rarity: 4, role: 'knight', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'assassin-cartuja',
    name: 'Cartuja assassin',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'assassin-cidd',
    name: 'Cidd assassin',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  { _id: 'assassin-coli', name: 'Coli assassine', rarity: 4, role: 'assassin', attribute: 'dark', zodiac: 'bull' },
  { _id: 'auxiliary-lots', name: 'Lots auxiliaire', rarity: 4, role: 'mage', attribute: 'dark', zodiac: 'fish' },
  {
    _id: 'benevolent-romann',
    name: 'Romann bienveillant',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  { _id: 'blaze-dingo', name: 'Dingo ardent', rarity: 4, role: 'manauser', attribute: 'light', zodiac: 'archer' },
  {
    _id: 'blood-blade-karin',
    name: 'Karine Lame de Sang',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  { _id: 'cartuja', name: 'Cartuja', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  {
    _id: 'celestial-mercedes',
    name: 'Mercedes c\u00e9leste',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'challenger-dominiel',
    name: 'Dominiel comp\u00e9titrice',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  { _id: 'champion-zerato', name: 'Zerato champion', rarity: 4, role: 'mage', attribute: 'dark', zodiac: 'ram' },
  { _id: 'cidd', name: 'Cidd', rarity: 4, role: 'assassin', attribute: 'wind', zodiac: 'ram' },
  { _id: 'clarissa', name: 'Clarissa', rarity: 4, role: 'warrior', attribute: 'ice', zodiac: 'lion' },
  { _id: 'coli', name: 'Coli', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'corvus', name: 'Corvus', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'crab' },
  {
    _id: 'crescent-moon-rin',
    name: 'Rin du croissant de lune',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'bull',
  },
  { _id: 'crimson-armin', name: 'Armin pourpre', rarity: 4, role: 'knight', attribute: 'light', zodiac: 'scales' },
  { _id: 'crozet', name: 'Crozet', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'crab' },
  { _id: 'dingo', name: 'Dingo', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'dominiel', name: 'Dominiel', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'fighter-maya', name: 'Maya combattante', rarity: 4, role: 'knight', attribute: 'light', zodiac: 'scales' },
  {
    _id: 'free-spirit-tieria',
    name: 'Tieria Esprit libre',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'maiden',
  },
  { _id: 'furious', name: 'Furious', rarity: 4, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'general-purrgis',
    name: 'G\u00e9n\u00e9ral Purrgis',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'great-chief-khawana',
    name: 'Grande chef Khawana',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'bull',
  },
  { _id: 'guider-aither', name: 'Guide Aither', rarity: 4, role: 'mage', attribute: 'light', zodiac: 'crab' },
  { _id: 'karin', name: 'Karine', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'khawana', name: 'Khawana', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  { _id: 'khawazu', name: 'Khawazu', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'scorpion' },
  {
    _id: 'kitty-clarissa',
    name: 'Clarissa le chaton',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'maiden',
  },
  { _id: 'kizuna-ai', name: 'Kizuna AI', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'crab' },
  { _id: 'leo', name: 'Leo', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'lots', name: 'Lots', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'twins' },
  { _id: 'maya', name: 'Maya', rarity: 4, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'mercedes', name: 'Mercedes', rarity: 4, role: 'mage', attribute: 'fire', zodiac: 'scorpion' },
  { _id: 'purrgis', name: 'Purrgis', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'rin', name: 'Rin', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'roaming-warrior-leo',
    name: 'L\u00e9o guerrier errant',
    rarity: 4,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'romann', name: 'Romann', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'twins' },
  { _id: 'rose', name: 'Rose', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'scales' },
  { _id: 'schuri', name: 'Schuri', rarity: 4, role: 'ranger', attribute: 'fire', zodiac: 'lion' },
  { _id: 'serila', name: 'Serila', rarity: 4, role: 'mage', attribute: 'fire', zodiac: 'waterbearer' },
  { _id: 'shadow-rose', name: "Rose de l'ombre", rarity: 4, role: 'knight', attribute: 'dark', zodiac: 'twins' },
  {
    _id: 'shooting-star-achates',
    name: 'Achates \u00c9toile filante',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'silk', name: 'Silk', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'sinful-angelica',
    name: 'Angelica P\u00e9cheresse',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'bull',
  },
  { _id: 'surin', name: 'Surin', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'tempest-surin',
    name: 'Surin Temp\u00eate',
    rarity: 4,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'twins',
  },
  { _id: 'troublemaker-crozet', name: 'Crozet Trublion', rarity: 4, role: 'knight', attribute: 'dark', zodiac: 'fish' },
  { _id: 'wanderer-silk', name: 'Silk nomade', rarity: 4, role: 'ranger', attribute: 'light', zodiac: 'goat' },
  {
    _id: 'watcher-schuri',
    name: 'Observateur Schuri',
    rarity: 4,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  { _id: 'zerato', name: 'Zerato', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'adlay', name: 'Adlay', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  { _id: 'adventurer-ras', name: 'Ras aventurier', rarity: 3, role: 'knight', attribute: 'fire', zodiac: 'scales' },
  { _id: 'ainos', name: 'Ainos', rarity: 3, role: 'manauser', attribute: 'dark', zodiac: 'archer' },
  { _id: 'ains', name: 'Ains', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  { _id: 'aither', name: 'Aither', rarity: 3, role: 'manauser', attribute: 'ice', zodiac: 'scales' },
  { _id: 'alexa', name: 'Alexa', rarity: 3, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'allrounder-wanda', name: 'Wanda Polyvalente', rarity: 3, role: 'ranger', attribute: 'dark', zodiac: 'twins' },
  {
    _id: 'angelic-montmorancy',
    name: 'Ang\u00e9lique Montmorancy',
    rarity: 3,
    role: 'manauser',
    attribute: 'ice',
    zodiac: 'fish',
  },
  { _id: 'arowell', name: 'Arowell', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'scales' },
  { _id: 'azalea', name: 'Azalea', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'scorpion' },
  { _id: 'bask', name: 'Bask', rarity: 3, role: 'knight', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'batisse', name: 'Batisse', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'bull' },
  {
    _id: 'butcher-corps-inquisitor',
    name: 'Inquisiteur des Bouchers',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  {
    _id: 'captain-rikoris',
    name: 'Capitaine Rikoris',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'carmainerose', name: 'Carmainerose', rarity: 3, role: 'mage', attribute: 'fire', zodiac: 'waterbearer' },
  { _id: 'carrot', name: 'Carrot', rarity: 3, role: 'mage', attribute: 'fire', zodiac: 'archer' },
  { _id: 'celeste', name: 'Celeste', rarity: 3, role: 'ranger', attribute: 'light', zodiac: 'archer' },
  {
    _id: 'chaos-inquisitor',
    name: 'Inquisiteur du Chaos',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  { _id: 'chaos-sect-axe', name: 'Hache du chaos', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'lion' },
  {
    _id: 'church-of-ilryos-axe',
    name: "Hache de l'\u00c9glise d'Ilryos",
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  { _id: 'commander-lorina', name: 'Commandant Lorina', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'lion' },
  {
    _id: 'doll-maker-pearlhorizon',
    name: 'Perlhorizon plangonophile',
    rarity: 3,
    role: 'mage',
    attribute: 'wind',
    zodiac: 'bull',
  },
  { _id: 'doris', name: 'Doris', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'crab' },
  { _id: 'eaton', name: 'Eaton', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'crab' },
  { _id: 'elson', name: 'Elson', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  { _id: 'enott', name: 'Enott', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scorpion' },
  {
    _id: 'falconer-kluri',
    name: 'Fauconni\u00e8re Kluri',
    rarity: 3,
    role: 'knight',
    attribute: 'wind',
    zodiac: 'ram',
  },
  { _id: 'glenn', name: 'Glenn', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'scales' },
  { _id: 'gloomyrain', name: 'Sombrepluie', rarity: 3, role: 'mage', attribute: 'light', zodiac: 'crab' },
  { _id: 'godmother', name: 'La Marraine', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'twins' },
  { _id: 'gunther', name: 'Gunther', rarity: 3, role: 'warrior', attribute: 'light', zodiac: 'scales' },
  { _id: 'hataan', name: 'Hataan', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'lion' },
  { _id: 'hazel', name: 'Hazel', rarity: 3, role: 'manauser', attribute: 'fire', zodiac: 'waterbearer' },
  { _id: 'helga', name: 'Helga', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  { _id: 'hurado', name: 'Hurado', rarity: 3, role: 'mage', attribute: 'dark', zodiac: 'fish' },
  { _id: 'ian', name: 'Ian', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'maiden' },
  { _id: 'jecht', name: 'Jecht', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'archer' },
  { _id: 'jena', name: 'Jena', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'judith', name: 'Judith', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  { _id: 'kikirat-v2', name: 'Kikirat v2', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'goat' },
  { _id: 'kiris', name: 'Kiris', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'kluri', name: 'Kluri', rarity: 3, role: 'knight', attribute: 'wind', zodiac: 'ram' },
  { _id: 'lena', name: 'L\u00e9na', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  { _id: 'lorina', name: 'Lorina', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'lion' },
  { _id: 'lucy', name: 'Lucie', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'magic-scholar-doris',
    name: 'Doris Mage \u00e9rudite',
    rarity: 3,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'mascot-hazel',
    name: 'Mascotte Hazel',
    rarity: 3,
    role: 'manauser',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
  {
    _id: 'mercenary-helga',
    name: 'Helga mercenaire libre',
    rarity: 3,
    role: 'warrior',
    attribute: 'wind',
    zodiac: 'archer',
  },
  { _id: 'mirsa', name: 'Mirsa', rarity: 3, role: 'assassin', attribute: 'light', zodiac: 'fish' },
  { _id: 'mistychain', name: 'Mornebrume', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'lion' },
  { _id: 'montmorancy', name: 'Montmorancy', rarity: 3, role: 'manauser', attribute: 'ice', zodiac: 'fish' },
  { _id: 'mucacha', name: 'Mucacha', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  { _id: 'muse-rima', name: 'Rima muse', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'nemunas', name: 'Nemunas', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'scales' },
  { _id: 'otillie', name: 'Otillie', rarity: 3, role: 'mage', attribute: 'dark', zodiac: 'bull' },
  { _id: 'pearlhorizon', name: 'Perlhorizon', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'bull' },
  { _id: 'pyllis', name: 'Pyllis', rarity: 3, role: 'knight', attribute: 'dark', zodiac: 'crab' },
  { _id: 'ras', name: 'Ras', rarity: 3, role: 'knight', attribute: 'fire', zodiac: 'scales' },
  { _id: 'requiemroar', name: 'Hurlerequiem', rarity: 3, role: 'manauser', attribute: 'dark', zodiac: 'archer' },
  { _id: 'researcher-carrot', name: 'Carrot chercheuse', rarity: 3, role: 'mage', attribute: 'fire', zodiac: 'archer' },
  {
    _id: 'righteous-thief-roozid',
    name: 'Digne voleur Roozid',
    rarity: 3,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'twins',
  },
  { _id: 'rikoris', name: 'Rikoris', rarity: 3, role: 'warrior', attribute: 'light', zodiac: 'scales' },
  { _id: 'rima', name: 'Rima', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'roozid', name: 'Roozid', rarity: 3, role: 'assassin', attribute: 'wind', zodiac: 'twins' },
  { _id: 'sonia', name: 'Sonia', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  { _id: 'sven', name: 'Sven', rarity: 3, role: 'assassin', attribute: 'dark', zodiac: 'scorpion' },
  { _id: 'taranor-guard', name: 'Garde de Taranor', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  {
    _id: 'taranor-royal-guard',
    name: 'Garde royal de Taranor',
    rarity: 3,
    role: 'knight',
    attribute: 'ice',
    zodiac: 'scorpion',
  },
  { _id: 'tieria', name: 'Tieria', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'ram' },
  { _id: 'wanda', name: 'Wanda', rarity: 3, role: 'ranger', attribute: 'dark', zodiac: 'twins' },
  {
    _id: 'zealot-carmainerose',
    name: 'Carmainerose z\u00e9latrice',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
];
